import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    ConfigurationSynopticTemplateOntologyCreateRequest,
    ConfigurationSynopticTemplateOntologyResponse
} from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template-ontology/configuration-synoptic-template-ontology.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'

class ConfigurationSynopticTemplateOntologyService {
    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationSynopticTemplateOntologyResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSynopticTemplateOntologyResponse>>(`/configuration/laboratories/${laboratoryId}/synopticTemplateOntologies`, { ...filterModel }, { params })
        return response.data
    }

    async create(laboratoryId: number, request: ConfigurationSynopticTemplateOntologyCreateRequest): Promise<ConfigurationSynopticTemplateOntologyResponse> {
        const response = await axios.post<ConfigurationSynopticTemplateOntologyResponse>(`/configuration/laboratories/${laboratoryId}/synopticTemplateOntologies`, request)
        return response.data
    }

    async delete(laboratoryId: number, synopticTemplatesOntologyId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/synopticTemplateOntologies/${synopticTemplatesOntologyId}`)
        return response.data
    }
}
export const configurationSynopticTemplateOntologyService = new ConfigurationSynopticTemplateOntologyService()
